"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _iconsReact = require("../../icons-react");
var _excluded = ["placeholder", "readOnly", "isRequired"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var EditableSubject = /*#__PURE__*/function (_React$PureComponent) {
  function EditableSubject(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, EditableSubject);
    _this = _callSuper(this, EditableSubject, [props]);
    _this.state = {
      initialValue: props.value,
      isEditing: false,
      value: props.value
    };
    _this.textarea = /*#__PURE__*/_react["default"].createRef();
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.resizeTextarea = _this.resizeTextarea.bind(_this);
    _this.toggleEdit = _this.toggleEdit.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(EditableSubject, _React$PureComponent);
  return (0, _createClass2["default"])(EditableSubject, [{
    key: "handleChange",
    value: function handleChange(_ref) {
      var target = _ref.target;
      this.setState({
        value: target.value
      }, this.resizeTextarea);
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var onSubmit = this.props.onSubmit;
      var value = this.state.value;
      onSubmit({
        value: value
      });
      this.toggleEdit(false);
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      var initialValue = this.state.initialValue;
      this.setState({
        value: initialValue
      });
      this.toggleEdit(false);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(_ref2) {
      var key = _ref2.key;
      if (key === 'Backspace') {
        this.textarea.current.style.height = this.minTextareaHeight;
      }
      if (key === 'Enter') {
        this.handleSubmit();
      }
      if (key === 'Escape') {
        this.handleCancel();
      }
    }
  }, {
    key: "toggleEdit",
    value: function toggleEdit(isEditing) {
      var _this2 = this;
      var readOnly = this.props.readOnly;
      if (readOnly) {
        return;
      }
      this.setState({
        isEditing: isEditing
      }, function () {
        return _this2.initialResize();
      });
    }
  }, {
    key: "initialResize",
    value: function initialResize() {
      if (!this.textarea.current) {
        return;
      }
      this.minTextareaHeight = window.getComputedStyle(this.textarea.current).getPropertyValue('min-height');
      this.textarea.current.style.height = this.minTextareaHeight;
      this.resizeTextarea();
    }
  }, {
    key: "resizeTextarea",
    value: function resizeTextarea() {
      var el = this.textarea.current;
      var scrollHeight = el.scrollHeight;
      el.style.height = "".concat(scrollHeight, "px");
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        isEditing = _this$state.isEditing,
        value = _this$state.value;
      var _this$props = this.props,
        placeholder = _this$props.placeholder,
        readOnly = _this$props.readOnly,
        isRequired = _this$props.isRequired,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledEditableSubject, props, isEditing ? /*#__PURE__*/_react["default"].createElement(StyledTextarea, {
        autoFocus: true,
        value: value,
        ref: this.textarea,
        placeholder: placeholder,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleSubmit
      }) : /*#__PURE__*/_react["default"].createElement(StyledEditButton, {
        title: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        onClick: function onClick() {
          return _this3.toggleEdit(true);
        }
      }, /*#__PURE__*/_react["default"].createElement(StyledValue, null, value, !value && /*#__PURE__*/_react["default"].createElement(StyledPlaceholder, {
        isRequired: isRequired
      }, placeholder), !readOnly && /*#__PURE__*/_react["default"].createElement(StyledEditIcon, null))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref3, _ref4) {
      var value = _ref3.value;
      var initialValue = _ref4.initialValue;
      if (value === initialValue) return null;
      return {
        initialValue: value,
        value: value
      };
    }
  }]);
}(_react["default"].PureComponent);
EditableSubject.propTypes = {
  className: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  value: _propTypes["default"].string
};
EditableSubject.defaultProps = {
  className: '',
  onSubmit: Function.prototype,
  placeholder: null,
  readOnly: false,
  value: ''
};
var StyledEditIcon = (0, _styledComponents["default"])(_iconsReact.Edit).withConfig({
  displayName: "EditableSubject__StyledEditIcon",
  componentId: "sc-je6zcr-0"
})(["margin-left:5px;margin-bottom:-2px;opacity:0;cursor:pointer;width:14px;height:15px;path{stroke:#007aff;}"]);
var StyledEditableSubject = _styledComponents["default"].div.withConfig({
  displayName: "EditableSubject__StyledEditableSubject",
  componentId: "sc-je6zcr-1"
})(["color:#17181a;display:flex;font-size:18px;font-weight:500;:hover{", "{opacity:1;}}"], StyledEditIcon);
var StyledTextarea = _styledComponents["default"].textarea.withConfig({
  displayName: "EditableSubject__StyledTextarea",
  componentId: "sc-je6zcr-2"
})(["width:100%;resize:none;font-size:18px;font-family:'ONYOneFont','Helvetica',sans-serif;background:none;min-height:28px;border:none;padding:2px;font-weight:500;"]);
var StyledPlaceholder = _styledComponents["default"].span.withConfig({
  displayName: "EditableSubject__StyledPlaceholder",
  componentId: "sc-je6zcr-3"
})(["color:#757575;", ""], function (_ref5) {
  var isRequired = _ref5.isRequired;
  return isRequired && (0, _styledComponents.css)(["&::after{content:' *';color:red;}"]);
});
var StyledValue = _styledComponents["default"].span.withConfig({
  displayName: "EditableSubject__StyledValue",
  componentId: "sc-je6zcr-4"
})(["display:inline-block;"]);
var StyledEditButton = _styledComponents["default"].span.withConfig({
  displayName: "EditableSubject__StyledEditButton",
  componentId: "sc-je6zcr-5"
})(["margin-left:2px;font-size:18px;min-height:28px;padding:2px 0;"]);
EditableSubject.StyledTextarea = StyledTextarea;
var _default = exports["default"] = EditableSubject;